<script setup lang="ts">
import { ZFeedbackPage } from '@zoomcatalog/design-system';

const locale = {
  NO_RESULTS_TITLE: 'This design is empty',
  NO_RESULTS_MESSAGE:
    'The person who created this design has not added anything yet.',
};
</script>

<template>
  <ZFeedbackPage>
    <template #title>
      {{ locale.NO_RESULTS_TITLE }}
    </template>
    <template #description>
      {{ locale.NO_RESULTS_MESSAGE }}
    </template>
  </ZFeedbackPage>
</template>
